import {Component,OnInit,OnDestroy,ViewChild,ElementRef} from '@angular/core';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SocketsService } from 'src/app/shared/socket/sockets.service';
import * as moment from 'moment';
import { map, take } from 'rxjs/operators';
// import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { pipe, Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import {FormGroup,FormControl,Validators} from '@angular/forms';
// import * as moment from 'moment';
import { SelectItem } from 'primeng/api/selectitem';
import { ArgumentType } from '@angular/compiler/src/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  selectedItems: any[] = [];
  items: any[] = [
    { label: 'Item 1', value: 'item1' },
    { label: 'Item 2', value: 'item2' },
    { label: 'Item 3', value: 'item3' },
    { label: 'Item 4', value: 'item4' },
    // ... other items
  ];
  member:any=null;
  token: string;
  userToken: string;
  clinicStatus: any;
  moment:any =moment;
  id: string;
  imagePath: any;
  imgURL: any;
  bookappointment:any;
  skipDaysArray:any =[];
  imgClinicForm: FormGroup;
  changeSlotForm:FormGroup;
  bookappttime: boolean = false;
  path: string = 'https://dev.api.doqmatokens.com/';
  myid: string;
  appDoc: {
    doc: {
      consultationFee: { firstVisit: number };
      _id: string;
      clinicId: { patientLimit: number; _id: string };
    };
    appData: number;
  } = {
    doc: {
      consultationFee: { firstVisit: 0 },
      _id: null,
      clinicId: { patientLimit: 0, _id: null }
    },
    appData: 0
  };
  subs: Subscription;
  clinicData: any;
  recptform: FormGroup;
  clinicArray = [];

  clinicId: any;
  clinicname:string;
  type:any;
  skipDays:any;
  clinicName: any;
  curIndex: any;
  weekDays = [];
  selectedfile: File;
  cddForm: FormGroup;
  viewclinicForm:any=FormGroup;
  viewclinic:any;
  patientAge:number;
  AgeType:number;
  showDiv: boolean = false;
  phoneNo: number;
  patientName: string;
  // end
  degrees: SelectItem[];
  clinicDays: SelectItem[];
  changeable:boolean= true;
  @ViewChild('closeclinicmodal', { static: false }) sRef: ElementRef;
  @ViewChild('closeClinicDeleteModal', { static: false }) cRef: ElementRef;
  @ViewChild('changeSlotModelClose',{static:false}) slotRef:ElementRef;
  isLoading = false;
  ShowDelete: boolean = false;
  selectedImageUrl:any;
  doctype:any;
  showAppt:any =false;
  members: any;
  test: any;
  ammount: number=null;
  testArray: any[];
  deposit: any = null;
  paymentType: any = 'cash';
  // skipDaysArray: any[];

  constructor(
    private authService: AuthService,
    private socketService: SocketsService,
    private doctorService: DoctorsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    // setInterval(()=>{
    //   console.log(this.selectedItems);
    // },1000);
    this.authService.authDataSubject.pipe(take(1)).subscribe(authData => {
      this.userToken = authData._token;
      this.id = authData._id;
      this.doctype = authData._type;
      console.log(this.id);
    });
    this.recptform = new FormGroup({
      ageType: new FormControl('year',Validators.required),
      GuardiansName : new FormControl(null,Validators.required),
      doctorId: new FormControl(this.id),
      phoneNo: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientAge: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      name: new FormControl(null,Validators.required),
      address: new FormControl(null,Validators.required),
      skipDays: new FormControl(0)
    })
    // this.getTest();
    this.cddForm = new FormGroup({
      clinicName: new FormControl(null),
      weekDays: new FormControl(null),
      patientLimit: new FormControl(null, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ]),
      line1: new FormControl(null),
      city: new FormControl(null),
      slots: new FormControl(null),
      district: new FormControl(null),
      pincode: new FormControl(null, [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      state: new FormControl(null),
      startTime: new FormControl(null),
      endTime: new FormControl(null)
    });
    this.degrees = [
      { label: 'MBBS', value: { name: 'MBBS' } },
      { label: 'BDS', value: { name: 'BDS' } },
      { label: 'MD', value: { name: 'MD' } },
      { label: 'BSC Nursing', value: { name: 'BSC Nursing' } },
      { label: 'B.Pharmacy', value: { name: 'B.Pharmacy' } }
    ];
    this.clinicDays = [
      { label: 'Sunday', value: 'Sunday' },
      { label: 'Monday', value: 'Monday' },
      { label: 'Tuesday', value: 'Tuesday' },
      { label: 'Wednesday', value: 'Wednesday' },
      { label: 'Thursday', value: 'Thursday' },
      { label: 'Friday', value: 'Friday' },
      { label: 'Saturday', value: 'Saturday' }
    ];
    this.changeSlotForm = new FormGroup({
      slot:new FormControl(null),
      clinicId: new FormControl(null)
    });
    this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
      (this.id = res._id), (this.token = res._token);
    });
    // this.oninitClinicForm(this.clinicData);
    this.gelAllClinic();
    // this.getMember();
    // this.getTest();

    this.subs = this.socketService.onNewAppointmentMessage().subscribe(res => {
      console.log("this is socket",res);
      if(res && res.appointment && res.patientData && this.moment().format('MMMM Do YYYY') == this.moment(res.appointment.appointmentDate).format('MMMM Do YYYY')){
        this.appDoc.appData = res.appCount;
      }
    });
    this.viewclinicForm = new FormGroup({
      imgForm: new FormControl(''),
    });
    // this.status();
  }
  send() {
    if (this.ShowDelete !== false) {
      this.ShowDelete = false;
    } else {
      this.ShowDelete = true;
    }
  }

  getMember(clinicId){
    this.doctorService.getMember(clinicId,this.userToken).subscribe((res:any)=>{
      console.log(res);
      this.members= res;
      this.member = this.members[0]._id;
    })
  }
 
  advance() {
    this.showDiv = !this.showDiv;
    this.getTest();
    this.getMember(this.clinicId);
  }

  
  Bookreceptionist(){
    this.isLoading = true;
    console.log("this is form control value ",this.recptform)
    this.doctorService.BookReceptionist(this.recptform.value, this.token).subscribe((res:any) =>
      {
       if(this.showDiv) {
          let postData = {
          testId:this.testArray,
          memberId:this.member,
          amount:this.ammount,
          deposit:this.deposit,
          balance:this.ammount- this.deposit,
          paymentType:this.paymentType,
          appointmentId:res.appointment._id
        };
        this.doctorService.saveAppointmentTransaction(postData,this.token).subscribe((response)=>{
          this.isLoading = false;
          this.showAppt = true;
          this.bookappointment = res.appointment;
          this.showDiv = false;
          this.testArray = [];
          this.ammount = null;
          this.member = this.members[0]._id;
          this.deposit = null;
          this.selectedItems = [];
          // window.alert(`${this.bookappointment.patientName} , Your Appointment is Booked Successfully. Your Appointment Number is ${this.bookappointment.appointmentNumber}`);
          console.log('this is receptionist', res);
        })
      }else{
        this.isLoading = false;
          this.showAppt = true;
          this.bookappointment = res.appointment;
          // window.alert(`${this.bookappointment.patientName} , Your Appointment is Booked Successfully. Your Appointment Number is ${this.bookappointment.appointmentNumber}`);
          console.log('this is receptionist', res);
      }
      },(err)=>{
        this.isLoading=false;
        console.log("this is error",err);
        if(err.error.status >= 400){
          // alert(err.error.message);
        }
      }
    )
  }
  onChangeTests(value){
    console.log(value.value);
    var amount = 0;
    this.testArray= [];
    value.value.map((t)=>{
      var price = this.test.filter((item)=> item.testId._id === t)[0].price;
      this.testArray.push({id:t,price:price});
      amount = amount + price;
    });
    console.log(amount);
    this.ammount = amount
    
  }
  
  onChangeAmmount(value){
    console.log(value.target.value);
    this.ammount = Number(value.target.value);
  }
  
  onChangeDeposit(value){
    console.log(value.target.value);
    this.deposit = Number(value.target.value);
  }

  onChangeDiscount(value){
    console.log(value.target.value);
    let amount= 0
    this.selectedItems.map((t)=>{
      var price = this.test.filter((item)=> item.testId._id === t)[0].price;
      amount = amount + price;
    });
    console.log(amount);
    this.ammount = amount;
    this.ammount = this.ammount - value.target.value;
  }
  
  onNewPatient(){
    this.showAppt = false;
    this.recptform = new FormGroup({
      ageType: new FormControl('year',Validators.required),
      GuardiansName : new FormControl(null,Validators.required),
      doctorId: new FormControl(this.id),
      phoneNo: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientAge: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      name: new FormControl(null,Validators.required),
      address: new FormControl(null,Validators.required)
    })
  }
  doctorType(){
  this.doctorService.getDocType(this.authService).subscribe((res:any)=>
  {
    this.Bookreceptionist = res.appointment;
    console.log("appoint is done", res);
  }
  )
  }

  oninitClinicForm(clinicData) {
    console.log('Working days', clinicData.timming.endTime);
    var clinicName = clinicData.clinicName;
    const patientLimit = clinicData.patientLimit;
    const city = clinicData.address.city;
    const state = clinicData.address.state;
    const district = clinicData.address.district;
    const pincode = clinicData.address.pincode;
    const line1 = clinicData.address.line1;
    var startTime = moment(clinicData.timming.startTime, ['h:mm A']).format(
      'HH:mm'
    );
    var endTime = moment(clinicData.timming.endTime, ['h:mm A']).format(
      'HH:mm'
    );
    var weekDays = clinicData.weekDays;
    this.cddForm = new FormGroup({
      clinicName: new FormControl(clinicName),
      weekDays: new FormControl(weekDays),
      patientLimit: new FormControl(patientLimit, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ]),
      line1: new FormControl(line1),
      city: new FormControl(city),
      district: new FormControl(district),
      pincode: new FormControl(pincode, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ]),
      state: new FormControl(state),
      startTime: new FormControl(startTime),
      endTime: new FormControl(endTime)
    });
  }

  deleteImage(index) {
    this.doctorService
      .delImage(this.token, this.clinicId, index)
      .subscribe(res => {
        this.gelAllClinic();
      });
  }

  getTest(){
    console.log(this.clinicData?._id,"this is clinicId")
    this.doctorService.getTest(this.token,this.clinicData?._id).subscribe((res:any)=>{
      this.test= res.tests;
      this.items = this.test.map((t)=>({label:t.testId.name+"("+t.price+")",value:t.testId._id}))
      console.log(this.test,"this is trsts");
    })
  }
  //Add Clinic Images Start Here
  onSubmit() {
    this.isLoading = true;
    console.log('Add Doctor Service');
    this.doctorService
      .updateClinicPhotos(this.token, this.clinicId, this.selectedfile)
      .subscribe(res => {
        this.gelAllClinic();
        this.isLoading = false;
// document.getElementById("uploadimage").style.display = "none";
document.getElementById("uploadimg").style.display=" none";
document.getElementById("selectimage").style.display = "block";
// console.log(document.getElementById("selectimage").style.display,"selectimage");
// console.log('successfully uploaded');
      });
  }
  cencleuploade(){
    document.getElementById("uploadimg").style.display=" none";
    document.getElementById("selectimage").style.display = "block";
  }
  showupload(){
    // document.getElementById("uploadimage").style.display = "block";
    document.getElementById("selectimage").style.display = "none";
    document.getElementById("uploadimg").style.display=" inline-block";
  }
  deleteClinic(clinicId, doctorId) {
    this.doctorService
      .onDeleteClinic(clinicId, doctorId, this.token)
      .subscribe(res => {
        this.gelAllClinic();
        this.cRef.nativeElement.click();

        console.log('got resulr', res);
      });
  }
  onSubmitClinicData() {
    this.isLoading = true;
    const patientLimit = this.cddForm.value['patientLimit'];
    let workingweekDays = this.cddForm.value['weekDays'];
    console.log('OFMR VALUE', this.cddForm.value['weekDays']);
    let startTime = this.cddForm.value['startTime'];
    let endTime = this.cddForm.value['endTime'];
    const clinicName = this.cddForm.value['clinicName'];
    const district = this.cddForm.value['district'];

    const line1 = this.cddForm.value['line1'];
    const city = this.cddForm.value['city'];
    const pincode = this.cddForm.value['pincode'];
    const state = this.cddForm.value['state'];
    this.doctorService
      .setClinicData(
        workingweekDays,
        patientLimit,
        this.clinicData._id,
        startTime,
        endTime,
        clinicName,
        district,
        line1,
        city,
        pincode,
        state,
        this.userToken
      )
      .subscribe(
        res => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully update the clinic data '
          });
          this.gelAllClinic();
          this.sRef.nativeElement.click();
        },
        error => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to update the clinic '
          });
        }
      );
  }
  // oninitForm() {

  //   }
  // }
  onfilechange(event) :void{
    this.selectedfile = <File>event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onload = e => this.selectedImageUrl = reader.result;

      reader.readAsDataURL(file);
      this.showupload();
  }
   
    this.gelAllClinic();
  }

  //Add Clinic Images End Here
  //appointments/cdashboard
  onStartClinic() {
    var payload = {
      clinicId: this.clinicId,
      clinicStatus: 'ONLINE'
    };
    this.doctorService
      .changeClinicStaus(this.clinicId, payload, this.token)
      .subscribe(res => {
        this.clinicStatus = res;
        this.router.navigate(['appointmentsdashboard'], {
          relativeTo: this.activatedRoute
        });
      });
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }
  changeclinic(index, cid) {
    console.log('index of clinic', index);
    this.clinicData = this.clinicArray[index];
    console.log("clinic Data ",this.clinicData);
    if(this.clinicData && this.clinicData.hospitalId && this.clinicData.hospitalId._id){
      this.changeable = false;
      console.log("changeable",this.changeable)
    }else{
      this.changeable = true;
      console.log("changeable",this.changeable)
    }
    this.curIndex = index;
    this.clinicId = cid;
    console.log('Change Clinic', this.clinicArray[this.curIndex]);
    this.oninitClinicForm(this.clinicData);
    localStorage.setItem('activeClinic', JSON.stringify(this.clinicId));
    this.getAppDocData();
    this.changeSlotForm = new FormGroup({
      slot :new FormControl(this.clinicArray[this.curIndex].slot),
      clinicId:new FormControl(this.clinicArray[this.curIndex]._id)
    })
    console.log(this.clinicId);
  }
  onChangeClinic(index) {
    this.clinicData = this.clinicArray[index];
    console.log("clinicData",this.clinicData)
    this.clinicId = this.clinicData._id;
    localStorage.setItem('activeClinic', JSON.stringify(this.clinicId));
    this.getAppDocData();
  }

  gelAllClinic() {
    this.doctorService.getAllClinic(this.id, this.token).subscribe(res => {
      console.log("this is clinic >>>>>>>" ,res)
      // coonsole.log("this is skipdays" res.c)
      var clAr = [];
      res.clinics.map((item, index) => {
        let strttm = item.timming ? item.timming.startTime.toString() : null;
        let endtm = item.timming ? item.timming.endTime.toString() : null;
        var strtTime = moment(strttm, ['h:mm']).format('hh:mm A');
        var edTime = moment(endtm, ['h:mm']).format('hh:mm A');
        console.log('Printing startTime Changes', strtTime);
        item.timming = {
          startTime: strtTime,
          endTime: edTime
        };
        clAr.push(item);
      });
      this.clinicArray = clAr;
      this.curIndex = 0;
      this.clinicData = this.clinicArray[0];
      console.log("clinic Data",this.clinicData)
      if(this.clinicData && this.clinicData.hospitalId && this.clinicData.hospitalId._id){
        this.changeable = false;
      }else{
        this.changeable = true;
      }
      console.log('IMAGE ', this.clinicArray);
      this.oninitClinicForm(this.clinicData);
      console.log('CLINIC DATA 111', this.clinicData.clinicName);
      this.clinicId = this.clinicData._id;
      this.skipDays = this.clinicData?.skipDays;
      console.log("this is skipdays>>>>>", this.skipDays);
      this.skipDaysArray = Array(this.clinicData?.skipDays).fill(null);
      localStorage.setItem('activeClinic', JSON.stringify(this.clinicId));
      this.getAppDocData();
      this.changeSlotForm = new FormGroup({
        slot :new FormControl(this.clinicArray[this.curIndex].slot),
        clinicId:new FormControl(this.clinicArray[this.curIndex]._id)
      })
    });
  }

  getAppDocData() {
    this.doctorService
      .setdocDashData(this.id, this.token, this.clinicId)
      .subscribe(res => {
        this.appDoc = res.data;
      });
  }
  dumyfun(index:any){
    this.viewclinic=index;
    console.log("this is img",index);
    
    
  }
  dcCounter() {
    if(this.changeable){
      this.viewclinic = this.viewclinic -1;
    if(this.viewclinic < 0){
      let i=this.clinicArray[this.curIndex]?.clinicImages.length;
      this.viewclinic = i - 1;
    }
    }else{
      this.viewclinic = this.viewclinic -1;
       if(this.viewclinic < 0){
         let i=this.clinicArray[this.curIndex]?.hospitalId.hospitalImages.length;
         this.viewclinic = i - 1;
       }
    }
  }
  incCounter() {
    if(this.changeable){
      this.viewclinic = this.viewclinic +1;
     if(this.viewclinic >= this.clinicArray[this.curIndex]?.clinicImages.length){
       this.viewclinic = 0;
     }
    }else{
      this.viewclinic = this.viewclinic +1;
       if(this.viewclinic >= this.clinicArray[this.curIndex]?.hospitalId.hospitalImages.length){
         this.viewclinic = 0;
       
       }
    }
   }
   selectSlot(slot:any){
    this.changeSlotForm.value.slot = slot;
   }
   changeSlot(){
    console.log("this is form value ",this.changeSlotForm.value);
    this.doctorService.changeSlot(this.changeSlotForm.value,this.token).subscribe((res:any)=>{
      console.log("this is respose",res);
      this.clinicArray[this.curIndex] = res.data;
      this.getAppDocData();
      this.slotRef.nativeElement.click();
      alert("successFull Updated");
    })
   }
}